var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_27895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000488281,
    width: 43,
    height: 43,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_27895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95815 37.6254C7.97273 37.6254 7.12916 37.2745 6.42742 36.5728C5.72568 35.8711 5.37482 35.0275 5.37482 34.0421V8.95875C5.37482 7.97333 5.72568 7.12975 6.42742 6.42802C7.12916 5.72628 7.97273 5.37541 8.95815 5.37541H34.0415C35.0269 5.37541 35.8705 5.72628 36.5722 6.42802C37.2739 7.12975 37.6248 7.97333 37.6248 8.95875V34.0421C37.6248 35.0275 37.2739 35.8711 36.5722 36.5728C35.8705 37.2745 35.0269 37.6254 34.0415 37.6254H8.95815ZM8.95815 34.0421H34.0415V8.95875H8.95815V34.0421ZM10.7498 30.4587H32.2498L25.5311 21.5004L20.1561 28.6671L16.1248 23.2921L10.7498 30.4587Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultItemIcon);
export default __webpack_public_path__ + "static/media/default-item-icon.8a71059ee7d0ca846b0bea525e573fc7.svg";
export { ForwardRef as ReactComponent };